// Unpublished Work © 2022-2023 Deere & Company

import {
    RESET_DBS_CUSTOMER_PROFILE, SET_DBS_CUSTOMER_PROFILE_ERROR,
    SET_DBS_CUSTOMER_PROFILE_PAGE_STATUS
} from '../../action-list';
import {PageStatus} from '../../state/struct/page-status';

const setCustomerProfilePageStatus = (state, action) => action.pageStatus;

const resetProfileStatus = () => PageStatus.meta.map.COMPLETE;

const setErrorPageStatus = () => PageStatus.meta.map.ERROR;

export function status(state = PageStatus.meta.map.COMPLETE, action = {}) {
    const actionHandlers = {
        [SET_DBS_CUSTOMER_PROFILE_PAGE_STATUS]: setCustomerProfilePageStatus,
        [RESET_DBS_CUSTOMER_PROFILE]: resetProfileStatus,
        [SET_DBS_CUSTOMER_PROFILE_ERROR]: setErrorPageStatus
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
